;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .controller('ModifyCustomFieldsModalController', ModifyCustomFieldsModalController)

  ModifyCustomFieldsModalController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    'customFields', 'model'
  ]

  function ModifyCustomFieldsModalController (// Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    customFields, model
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        customFields: customFields,
        model: model
        // Public Methods
      })
    }
  }
})(window.angular, window._)
